module.exports = __webpack_public_path__ + "static/media/mundinError.ee6596b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/mundinError.png
// module id = 228
// module chunks = 0